import React, { createContext, useContext, useEffect, useState } from 'react';

export const COLOR_THEMES = {
  blue:   { name: 'Ocean Blue',   hue: '221', sat: '83%', lit: '53%', bg: '#EFF6FF', dark: '#1E3A5F', swatch: '#3B82F6' },
  purple: { name: 'Royal Purple', hue: '262', sat: '83%', lit: '58%', bg: '#F5F3FF', dark: '#2E1065', swatch: '#8B5CF6' },
  green:  { name: 'Emerald',      hue: '142', sat: '71%', lit: '45%', bg: '#ECFDF5', dark: '#052E16', swatch: '#10B981' },
  orange: { name: 'Sunset',       hue: '25',  sat: '95%', lit: '53%', bg: '#FFF7ED', dark: '#431407', swatch: '#F97316' },
  rose:   { name: 'Rose',         hue: '346', sat: '77%', lit: '49%', bg: '#FFF1F2', dark: '#4C0519', swatch: '#F43F5E' },
  teal:   { name: 'Teal',         hue: '176', sat: '69%', lit: '40%', bg: '#F0FDFA', dark: '#042F2E', swatch: '#14B8A6' },
};

const ThemeContext = createContext({});

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('ims-dark-mode') === 'true';
  });
  const [colorKey, setColorKey] = useState(() => {
    return localStorage.getItem('ims-color-theme') || 'blue';
  });

  const color = COLOR_THEMES[colorKey] || COLOR_THEMES.blue;

  useEffect(() => {
    const root = document.documentElement;
    const { hue, sat, lit } = color;

    // Toggle dark class for Tailwind dark mode
    if (darkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    // Apply color theme CSS variables
    root.style.setProperty('--theme-hue', hue);
    root.style.setProperty('--theme-primary', `${hue} ${sat} ${lit}`);
    root.style.setProperty('--theme-primary-light', `${hue} ${sat} 97%`);
    root.style.setProperty('--theme-primary-dark', `${hue} ${sat} 36%`);
    root.style.setProperty('--ring', `${hue} ${sat} ${lit}`);

    // Store preferences
    localStorage.setItem('ims-dark-mode', darkMode);
    localStorage.setItem('ims-color-theme', colorKey);
  }, [darkMode, colorKey, color]);

  const toggleDark = () => setDarkMode(d => !d);
  const setColor = (key) => setColorKey(key);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDark, colorKey, setColor, color, themes: COLOR_THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
